import { gql } from "@apollo/client";
import { ContaminationDeclarationFields } from "../fragments/contaminationDeclaration";

export const ContaminationDeclaration = gql`
    query ContaminationDeclaration ($id: ID!) {
        contaminationDeclaration (contaminationDeclarationId: $id) {
            ...ContaminationDeclarationFields
        }
    }
    ${ContaminationDeclarationFields}
`;
